import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { label: 'Practice', path: '/question-practice', icon: 'BookOpen' },
    { label: 'Analytics', path: '/results-analytics', icon: 'BarChart3' },
    { label: 'Teaching', path: '/babok-teaching', icon: 'GraduationCap' },
    { label: 'Study Materials', path: '/study-materials', icon: 'Library' },
    { label: 'History', path: '/history', icon: 'Clock' },
    { label: 'Downloads', path: '/downloads', icon: 'Download' },
    { label: 'Profile', path: '/profile', icon: 'User' },
    { label: 'Login', path: '/login', icon: 'LogIn' },
    { label: 'Register', path: '/registration', icon: 'UserPlus' },
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="header-nav">
        <div className="header-container">
          <Link to="/dashboard" className="header-logo">
            <div className="header-logo-icon">
              <Icon name="GraduationCap" size={24} color="white" />
            </div>
            <span className="header-logo-text">BABOK Master Pro</span>
          </Link>

          <nav className="header-nav-list">
            {navigationItems?.map((item) => (
              <div key={item?.path} className="header-nav-item">
                <Link
                  to={item?.path}
                  className={`header-nav-link ${isActive(item?.path) ? 'active' : ''}`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </Link>
              </div>
            ))}
          </nav>

          <button
            className="header-mobile-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="header-mobile-menu animate-slide-down">
          <nav className="header-mobile-menu-list">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-mobile-menu-link ${isActive(item?.path) ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;